module.exports = __webpack_public_path__ + "img/11.866f8b83.png";